import { apiClient } from "../../shared/api/httpClient.js";

export async function login(credentials) {
  const response = await apiClient.post("/auth/login/", credentials);
  return response.data;
}

export async function loginWithEmailCode(payload) {
  const response = await apiClient.post("/auth/email/login/", payload);
  return response.data;
}

export async function getCurrentUser() {
  const response = await apiClient.get("/users/me/");
  return response.data;
}

export async function updateCurrentUser(payload) {
  const response = await apiClient.patch("/users/me/", payload);
  return response.data;
}

export async function uploadAvatar(file) {
  const formData = new FormData();
  formData.append("avatar", file);
  const response = await apiClient.post("/users/me/avatar/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}

export async function changePassword(payload) {
  await apiClient.post("/users/me/password/", payload);
}

export async function register(payload) {
  const response = await apiClient.post("/auth/register/", payload);
  return response.data;
}

export async function sendEmailVerificationCode(email, purpose = "register") {
  const response = await apiClient.post("/auth/email/send-code/", {
    email,
    purpose,
  });
  return response.data;
}
